import { withStyles } from '@material-ui/core/styles';
import styles from './GeneralOrderInfo.styles';
import GeneralOrderInfo from './GeneralOrderInfo';

export default withStyles(styles)(GeneralOrderInfo);
